import request from 'api/requestUtils'
import qs from 'qs'
import type { paths } from '@luxuryescapes/contract-svc-accommodation'
import generateOccupancyStringByRoom from 'lib/offer/generateOccupancyStringByRoom'

interface PropertyRatesParams {
  checkIn: string;
  checkOut: string;
  occupancies: Array<App.Occupants>;
  regionCode: string;
  currency: string;
}

type PropertyRatesResponse = paths['/api/accommodation/properties/availability']['get']['responses']['200']['content']['application/json']
// type PropertyRate = paths['/api/accommodation/properties/availability']['get']['responses']['200']['content']['application/json']['result']['properties'][0]

// NOTE: This is unfinished
// function mapPropertyRate(serverRate: PropertyRate, params: PropertyRatesParams): Array<App.OfferAvailableRate | App.BedbankRate> {
//   const allRates = Object.values(serverRate.rooms).flatMap(room => room.rates)
//   const duration = moment(params.checkOut).diff(params.checkOut, 'days')
//   return allRates.map((rate): App.OfferAvailableRate | App.BedbankRate => {
//     if ('reservationRoomTypeId' in rate.meta) {
//       // LPC rate
//       const surcharges = sum(rate.surcharges.map(charge => 'amount' in charge ? charge.amount : 0))
//       const memberPrice = rate.luxPlus?.beforeTaxesFeesPrice ?? 0
//       const lpcRate: App.OfferAvailableRate = {
//         offerId: rate.meta.offerId,
//         price: rate.total.sellingPrice,
//         memberPrice,
//         memberPriceWithSurcharge: rate.luxPlus?.sellingPrice ?? 0,
//         surcharge: surcharges,
//         hotelPrice: rate.total.beforeTaxesFeesPrice,
//         hotelMemberPrice: memberPrice,
//         hotelValue: rate.total.valuedUpToPrice ?? 0,
//         hotelMemberValue: rate.luxPlus?.valuedUpToPrice ?? 0,
//         flightPrice: 0,
//         extraGuestSurcharge: 0,
//         taxesAndFees: rate.total.taxesAndFees,
//         propertyFees: rate.total.propertyFees,
//         duration,
//         packageId: rate.meta.packageId,
//         packageUniqueKey: getPackageUniqueKey(rate.meta.packageId, duration, rate.meta.reservationRoomRateId),
//         roomRateId: rate.meta.reservationRoomRateId,
//         availableRooms: 0,
//         hasTactical: rate.meta.isTactical,
//       }
//       return lpcRate
//     } else {
//       // Bedbank rate
//       const bedbankRate: App.BedbankRate = {
//         id: rate.meta.bedbankRateId,
//         corporate: false,
//         boardCode: mapBedbankBoardCode(rate.boardCode),
//         bedGroups: [],
//         supplierCode: '',
//         roomId: rate.meta.bedbankRoomId,
//         room: undefined,
//         occupancyPricing: objectEntries(rate.occupancies ?? {}).map(([occupancy, [pricing]]) => ({
//           occupancy,
//           exclusive: pricing.total.beforeTaxesFeesPrice,
//           inclusive: pricing.total.sellingPrice,
//           total: pricing.total.sellingPrice,
//           taxesAndFees: pricing.total.taxesAndFees,
//           propertyFees: pricing.total.propertyFees,

//         })),
//         refundable: false,
//         partiallyRefundable: false,
//         isFlightBundle: !!rate.meta.isFlightBundle,
//         nights: duration,
//         totals: {
//           exclusive: rate.total.beforeTaxesFeesPrice,
//           inclusive: rate.total.sellingPrice,
//           propertyFees: rate.total.propertyFees,
//           total: rate.total.displayPrice ?? 0,
//           taxesAndFees: rate.total.taxesAndFees,
//           memberTotal: rate.luxPlus?.displayPrice ?? 0,
//           memberExclusive: rate.luxPlus?.beforeTaxesFeesPrice,
//           memberInclusive: rate.luxPlus?.sellingPrice,
//         },
//         cancellationPolicies: rate.cancellationPolicies,
//         cancellationPolicy: undefined,
//         value: rate.total.valuedUpToPrice ?? 0,
//         discount: rate.total.discount ?? 0,
//         memberDiscount: rate.luxPlus?.discount ?? 0,
//         inclusions: [],
//       }

//       return bedbankRate
//     }
//   })
// }

// NOTE: do not use - This is unfinished
// export function getPropertyRates(propertyId: string, params: PropertyRatesParams) {
//   const query = qs.stringify({
//     checkIn: params.checkIn,
//     checkOut: params.checkOut,
//     regionCode: params.regionCode,
//     currencyCode: params.currency,
//     occupancy: params.occupancies.map(generateOccupancyStringByRoom),
//     propertyIds: [propertyId],
//   })

//   return request.get<PropertyRatesResponse>(`/api/accommodation/properties/availability?${query}`).then(response => {
//     const rate = response.result.properties[propertyId]
//     if (rate) {
//       return mapPropertyRate(rate, params)
//     }
//   })
// }

/**
 * Retrieves a list of rate ids for the property given
 * Will include rate ids from both bedbank and LPC packages
 */
export function getPropertyRatesList(propertyId: string, params: PropertyRatesParams): Promise<Array<App.PropertyRateListRate>> {
  const query = qs.stringify({
    checkIn: params.checkIn,
    checkOut: params.checkOut,
    regionCode: params.regionCode,
    currencyCode: params.currency,
    occupancies: params.occupancies.map(generateOccupancyStringByRoom),
    propertyIds: propertyId,
  })

  return request.get<PropertyRatesResponse>(`/api/accommodation/properties/availability?${query}`).then(response => {
    const rate = response.result.properties[propertyId]
    if (rate) {
      return Object.values(rate.rooms).flatMap(room => room.rates.map((rate): App.PropertyRateListRate => {
        if ('reservationRoomTypeId' in rate.meta) {
          return {
            rateId: rate.meta.reservationRoomRateId,
            groupId: rate.meta.group?.id,
            packaged: false,
            packageId: rate.meta.packageId ?? rate.meta.lePackageId,
            key: [rate.meta.reservationRoomRateId, rate.meta.group?.id, rate.meta.lePackageId].join('-'),
          }
        } else {
          return {
            rateId: rate.meta.bedbankRateId,
            packaged: false,
            key: rate.meta.bedbankRateId,
          }
        }
      }))
    }
    return []
  })
}
